import createIcon from "../createIcon";
import React from "react";

export const ArrowUpIcon = createIcon({
  path: (
    <path
      d="M22.5795 17.4209L13.3995 26.6009C12.6195 27.3809 12.6195 28.6409 13.3995 29.4209C14.1795 30.2009 15.4395 30.2009 16.2195 29.4209L23.9995 21.6609L31.7595 29.4209C32.5395 30.2009 33.7995 30.2009 34.5795 29.4209C35.3595 28.6409 35.3595 27.3809 34.5795 26.6009L25.3995 17.4209C24.6395 16.6409 23.3595 16.6409 22.5795 17.4209Z"
      fill="currentColor"
    />
  )
});

export default ArrowUpIcon;
